import ArticlesByTagCategoryPage from 'components/pages/ArticlesByTagCategory';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import {
  getArticleCategoryInfo,
  getArticlesListByCategory,
  getLastArticleReviews,
} from 'services/article';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import BLOG from 'constants/blog';
import LINKS from 'constants/links';

const ArticlesByCategory = (props) => (
  <ArticlesByTagCategoryPage isCategoryPage {...props} />
);

export const getServerSideProps = async ({ params: { categorySlug } }) => {
  try {
    const [
      articles,
      category,
      reviews,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getArticlesListByCategory({
        categorySlug,
        limit: BLOG.ARTICLES.SERVER_SIDE_LIMIT,
      }),
      getArticleCategoryInfo({ categorySlug }),
      { fn: getLastArticleReviews(), fallback: getLastArticleReviews.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    if (!category.categoryName) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    return {
      props: {
        category,
        reviews,
        mainArticles: articles.articles.slice(0, BLOG.ARTICLES.MAIN_LIMIT),
        serverArticlesPage: {
          ...articles,
          articles: articles.articles.slice(BLOG.ARTICLES.MAIN_LIMIT),
        },
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default ArticlesByCategory;
